const updateVideoCarousel = (state = {}, action) => {
    const { type = null, datasource } = action;

    if (type === 'dataEngine_update_response') {
        if (datasource === 'gumbo') {
            const { gamePk, gameData: { teams } } = action?.data || {};
            return {
                ...state,
                gamePk,
                away: teams?.away?.id,
                home: teams?.home?.id,
                sportId: teams?.home?.sport?.id
            };
        } else if (datasource === 'contentGraph' || datasource === 'content') {
            const { highlightsByTypes : {
                highlights = []
            } } = action?.data || {};
            const topFive = highlights.slice(0, 5);

            return {
                ...state,
                highlights: topFive
            };
        } else if (datasource === 'schedule') {
            const { story = '' } = action?.data || {};
            return {
                ...state,
                storyUrl: story
            };
        }
    }

    return state;
};

export default updateVideoCarousel;
